import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { useMemo } from "react";
import { useTheme } from "styled-components";
import JsonLd from "../../../../../base/others/json-ld/index.js";
import Title from "../../../../../base/text/title/index.js";
import CardSkeletonDesktop from "../../../../cards/product-card/views/desktop/card-skeleton/index.js";
import { getTitle } from "../utils.js";
import { sliderConstantsProps } from "../../../../../structures/others/slider/constants.js";
import { genKey } from "../../../../../../helpers/keys.js";
import { useDown } from "../../../../../../hooks/media/useDown.js";
import CardViewMore from "./card-view-more/index.js";
import * as S from "./styled.js";
const CarouselProductDesktop = ({ props  })=>{
    const { ldjson , items =[] , className ='' , benefits , link , config , isLoading , banner , searcher , visibleCardsCount =false , defaultImage ={
        src: ''
    } , isFirstComponent =false  } = props ?? {};
    const title = getTitle(props?.title);
    const theme = useTheme();
    const isTablet = useDown('tablet');
    const slider = sliderConstantsProps(theme);
    const sliderWithBenefits = {
        breakpoints: {
            [theme.breakpoints.xxl]: {
                perPage: 3,
                perMove: 3
            },
            [theme.breakpoints.xl]: {
                perPage: 2,
                perMove: 2
            },
            [theme.breakpoints.tablet]: {
                perPage: 4,
                perMove: 4,
                pagination: true,
                navigation: false,
                arrows: false
            },
            [theme.breakpoints.lg]: {
                perPage: 3,
                perMove: 3
            }
        },
        perPage: 4,
        perMove: 4,
        pagination: false,
        arrows: true,
        paginationVariant: 'bottom',
        speed: 1000
    };
    const sliderWithCustomCards = {
        breakpoints: {
            [theme.breakpoints.xxl]: {
                perPage: 4,
                perMove: 4
            },
            [theme.breakpoints.xl]: {
                perPage: 4,
                perMove: 4
            },
            [theme.breakpoints.tablet]: {
                perPage: 3,
                perMove: 3,
                pagination: true,
                navigation: false,
                arrows: false
            },
            [theme.breakpoints.lg]: {
                perPage: 3,
                perMove: 3
            }
        },
        perPage: 5,
        perMove: 5,
        pagination: false,
        arrows: true,
        paginationVariant: 'bottom',
        speed: 1000
    };
    const hidePagination = !(benefits ?? banner);
    let sliderProps;
    if (hidePagination && !visibleCardsCount) {
        sliderProps = slider;
    } else if (visibleCardsCount) {
        sliderProps = sliderWithCustomCards;
    } else {
        sliderProps = sliderWithBenefits;
    }
    const skeleton = useMemo(()=>new Array(sliderProps.perPage).fill(undefined).map((_, index)=>/*#__PURE__*/ _jsx(S.CardSkeletonWrapper, {
                children: /*#__PURE__*/ _jsx(CardSkeletonDesktop, {})
            }, genKey(index))), [
        sliderProps.perPage
    ]);
    const productCards = useMemo(()=>{
        const productCards = items.map((item, index)=>{
            const generalConfig = {
                ...config,
                ...item.config
            };
            const literals = {
                ...item.config?.literals,
                ...config?.literals
            };
            const productCardSearcher = {
                ...searcher,
                ...item.searcher
            };
            return /*#__PURE__*/ _jsx(S.ProductCard, {
                ...item,
                searcher: productCardSearcher,
                config: {
                    ...generalConfig,
                    literals
                },
                defaultImage: defaultImage,
                isFirstComponent: isFirstComponent && index < 5
            }, genKey(item));
        });
        if (!link?.href) return productCards;
        return [
            ...productCards,
            /*#__PURE__*/ _jsx(CardViewMore, {
                link: link,
                content: config?.literals?.viewMore
            }, genKey(link))
        ];
    }, [
        config,
        defaultImage,
        items,
        link,
        searcher,
        isFirstComponent
    ]);
    const renderBanner = (benefits, banner)=>{
        if (benefits) return /*#__PURE__*/ _jsx(S.BenefitsCard, {
            ...benefits,
            className: classNames({
                'is-tablet': isTablet
            })
        });
        return banner && /*#__PURE__*/ _jsx(S.BannerCampaignVertical, {
            $isBanner: true,
            className: classNames({
                ['className']: !!className,
                'is-tablet': isTablet
            }),
            ...banner,
            modifiyHoverCard: true,
            titleAs: "h3"
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "CarouselProduct",
        className: classNames({
            ['className']: !!className
        }),
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                ...title
            }),
            /*#__PURE__*/ _jsxs(S.CarouselProductWrapper, {
                $isTablet: isTablet,
                children: [
                    renderBanner(benefits, banner),
                    /*#__PURE__*/ _jsxs(S.CarouselProductBox, {
                        className: classNames({
                            'has-benefits': !!benefits,
                            'has-banner': !!banner,
                            'is-tablet': isTablet
                        }),
                        children: [
                            /*#__PURE__*/ _jsx(S.ProductsSlider, {
                                $visibleCardsCount: visibleCardsCount,
                                ...sliderProps,
                                gap: 12,
                                children: isLoading ? skeleton : productCards
                            }),
                            ldjson?.scripts?.map((script)=>/*#__PURE__*/ _jsx(JsonLd, {
                                    structuredData: script
                                }, genKey(script)))
                        ]
                    })
                ]
            })
        ]
    });
};
export default CarouselProductDesktop;

//# sourceMappingURL=index.js.map